import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ToothIconProps {
    className?: string
}

export const ToothIcon: FC<ToothIconProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth={1.8}
            strokeLinecap='round'
            strokeLinejoin='round'
            aria-hidden='true'
            className={className}
        >
            <path d='M7.5 3C5 3 3.5 5 3.5 7.5c0 2 .7 3.3 1.2 4.6.6 1.6.8 3.6 1.1 5.5.3 2 .9 3.4 2.1 3.4 1.4 0 1.6-1.8 1.9-3.6.2-1.3.6-2.4 2.2-2.4s2 1.1 2.2 2.4c.3 1.8.5 3.6 1.9 3.6 1.2 0 1.8-1.4 2.1-3.4.3-1.9.5-3.9 1.1-5.5.5-1.3 1.2-2.6 1.2-4.6C20.5 5 19 3 16.5 3c-1.9 0-2.9 1-4.5 1S9.4 3 7.5 3z' />
            <path d='M9 6.5c1 .5 2 .7 3 .7' />
        </svg>
    )
}

interface BrandMarkProps {
    clinicName: string
    logo?: string | null
    subtitle?: string
    className?: string
    compact?: boolean
}

const BrandMark: FC<BrandMarkProps> = ({
    clinicName,
    logo,
    subtitle = 'Patient Management',
    className,
    compact = false
}): ReactNode => {
    return (
        <div className={cn('flex min-w-0 items-center gap-3', className)}>
            {logo ? (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                    src={logo}
                    alt=''
                    className={cn('shrink-0 rounded-xl bg-white object-contain ring-1 ring-border', compact ? 'size-8' : 'size-10')}
                />
            ) : (
                <span
                    className={cn(
                        'flex shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-primary to-info text-primary-foreground shadow-sm',
                        compact ? 'size-8' : 'size-10'
                    )}
                >
                    <ToothIcon className={compact ? 'size-4.5' : 'size-5.5'} />
                </span>
            )}

            <span className='flex min-w-0 flex-col'>
                <span className={cn('truncate font-heading font-bold uppercase tracking-[0.08em] text-foreground', compact ? 'text-[13px]' : 'text-sm')}>
                    {clinicName}
                </span>

                {!compact && (
                    <span className='truncate text-xs text-muted-foreground'>
                        {subtitle}
                    </span>
                )}
            </span>
        </div>
    )
}

export default BrandMark
